<template>
  <div id='Questions' >
	  <div  class="question-schedulebox" >
	          <div class="question-schedule" ></div>
	  </div>
    <plugin />
	<Alert :alertMsg='alertMsg' v-if='alertShow'  />
    <afterQuestion  v-if='end' :countid='count_id'/>
    <!-- <Header /> -->
      <!-- 目录 -->
      <div class='catalog' @click='dian' v-show='catalogShow'>

		<img :src='getImgUrl(1,log)' class='catalogImg' :class='log==1?"activeImg":""'>
        <div class='sx'></div>
        <img :src='getImgUrl(2,log)' class='catalogImg' :class='log==2?"activeImg":""'>
        <div class='sx'></div>
        <img :src='getImgUrl(3,log)' class='catalogImg' :class='log==3?"activeImg":""'>
        <div class='sx'></div>
        <img :src='getImgUrl(4,log)' class='catalogImg':class='log==4?"activeImg":""'>
      </div>
    <div class='questionBox' :class='dong?"doing":""' v-if='Qshow'>

<!-- 前一题 -->    
          <div class='Ac' :class='shang?"top":"left" ' >
		
            <Q5 v-if='lastquestionOptions.question_type==4' :Q="lastquestionOptions" :fn='nullQuestion' />
            <Q2 v-if='lastquestionOptions.question_type==1' :Q="lastquestionOptions" :fn='nullQuestion'/>
            <Q3 v-if='lastquestionOptions.question_type==2' :Q="lastquestionOptions"/>
            <Q4 v-if='lastquestionOptions.question_type==5' :Q="lastquestionOptions"/>
            <div class='questionBoxBottom'>
               <div  class='lastQ' v-show='lastquestionOptions.current_num>1'>
                <img src="../assets/CombinedShape0419.png" alt="上一题">
                <div>上一题</div>
              </div>

              <img src="../assets/icon-next.png"  alt="下一题"  class='nestQ' :class='keepQ?"":"image000"' v-show='lastquestionOptions.question_type==2||lastquestionOptions.question_type==5'>
			  
            </div>
          </div>
       
<!-- 后一题 -->
        <div class='Ac' :class='shang?"right":(xia?"left":"top") '>
            <Q1 v-if='questionOptions.question_type==4' :Q="questionOptions"  :fn='nextQuestionnaire' />
            <Q2 v-if='questionOptions.question_type==1' :Q="questionOptions"  :fn='nextQuestionnaire' />
            <Q3 v-if='questionOptions.question_type==2' :Q="questionOptions"/>
            <Q4 v-if='questionOptions.question_type==5' :Q="questionOptions"/>
          <div class='questionBoxBottom'>
            <div  class='lastQ' v-show='questionOptions.current_num>1'>
              <img src="../assets/CombinedShape0419.png" alt="上一题">
              <div>上一题</div>
            </div>
            <img src="../assets/icon-next.png" alt="下一题"  class='nestQ' :class='keepQ?"":"image000"'  v-show='questionOptions.question_type==2||questionOptions.question_type==5'>
          </div>
        </div>
        

<!-- 当前题 -->
        <div class='Ac' :class='xia?"top":"right"'  >

            <Q5 v-if='nextquestionOptions.question_type==4' :Q="nextquestionOptions"  :fn='nullQuestion'/>
            <Q2 v-if='nextquestionOptions.question_type==1' :Q="nextquestionOptions"  :fn='nullQuestion'/>
            <Q3 v-if='nextquestionOptions.question_type==2' :Q="nextquestionOptions"/>
            <Q4 v-if='nextquestionOptions.question_type==5' :Q="nextquestionOptions"/>

           <div class='questionBoxBottom'>
          <div @click='lastQuestionnaire' class='lastQ'>
            <div class='lastQuestionBtn'>上一题</div>
          </div>
          <div class='nextQuestionBtn' @click='nextQuestionnaire' :class='keepQ?"":"image000"' v-show='nextquestionOptions.question_type==2||nextquestionOptions.question_type==5'>下一题</div>
        </div>
        </div>
      </div>

  </div>
</template>

<script>

import Header from '@/components/header.vue'
import plugin from '@/components/plugin.vue'
import afterQuestion from '@/components/afterQuestion.vue'
import Alert from '@/popup/Alert.vue'
import Q1 from '@/components/questionsDetail1.vue'
import Q2 from '@/components/questionsDetail2.vue'
import Q3 from '@/components/questionsDetail3.vue'
import Q4 from '@/components/questionsDetail4.vue'
import Q5 from '@/components/questionsDetail1.vue'
export default {
  name: 'Questions',
  components: {
    Header,
    plugin,
    afterQuestion,
	Alert,
    Q1,Q2,Q3,Q4,Q5
  },
  data:function () {
    return{
      Qshow:true,                  //是否显示问卷
      end:false,
      firstPost:true,
      log:0,
      catalogShow:true,
      // last:1,
      // active:2,
      // next:4,
      xia:false,
      shang: false,
      dong: false,
      progressBar:0,                //答题进度
      endQuestion:false,
      count_id:0,
      questions:{
          is_up: 0,                 //是否查询上一题0不是，1是
          record_id: 0,             //问卷记录id，第一次请求为0
          question: [{              //请求下一题目数组,第一次请求写空数组
              question_id: 0,       //题目id
              answer_ids: [],       //用户选择的答案id组
              answer: ""            //非选择题答案，非选择题写空字符串
            }]
      },
      lastquestionOptions:{},       //上一题问卷
      questionOptions:{},           //当前题问卷
      nextquestionOptions:{},       //下一题问卷
	  alertShow:false,
	  alertMsg:"",
	  stopQ:false,					//阻止答题
	  keepQ:false,                  //是否可以答下一题 
    }
  },
  beforeCreate:function() {
    
   
  },
  created:function(){
   
    
  },

  mounted:function(){

    

    
    //if(this.$route.params.record_id!=0){
     // this.keepQuestion(this.$route.params.record_id)
     // return
    //}else{

   // setTimeout(()=>{
      this.log=1
      this.autolog()
      this.questionnaire()
     // },100)
    //}


    
    

    

      

  },
  methods: {
	  
	  //获取图片地址
	  getImgUrl(i,j){
	
		  let _url= ""
		  if(i==1&&j!=1){
			  _url = "question-base"
		  }
		  if(i==1&&j==1){
			  _url = "question-base-active"
		  }
		  
		  if(i==2&&j!=2){
		  			  _url = "question-xuqiu"
		  }
		  if(i==2&&j==2){
		  			  _url = "question-xuqiu-active"
		  }
		  
		  if(i==3&&j!=3){
		  			  _url = "question-shms"
		  }
		  if(i==3&&j==3){
		  			  _url = "question-shms-active"
		  }
		  
		  if(i==4&&j!=4){
		  			  _url = "question-qita"
		  }
		  if(i==4&&j==4){
		  			  _url = "question-qita-active"
		  }
	     return require("@/assets/"+_url+".png");
	  },
    // 接收子组件值
    showMsgFromChild:function(data){
      console.log("父组件：" + data)
    },
    // 点击目录
   dian(){
     // this.log++
   },
   // 目录自动消失
   autolog(){
    setTimeout(()=>{
      this.catalogShow = false
    },2000)
   },

   // 上一题动画
  lastQ(options){
      // this.last = this.active - 1
      this.shang =true
      this.dong=true
      $(".Ac").css("transition","all 1s")
      this.lastquestionOptions= Object.assign({},options)
      this.rest(1)
  },

  // 下一题动画
  nestQ(options){
       // this.next = this.active + 1
       this.xia=true
       this.dong=true
       $(".Ac").css("transition","all 1s")
       console.log(options)
       this.nextquestionOptions= Object.assign({},options)
       this.rest(2)
  },

  // 复位动画
  rest(num){
    if (num==2){
      console.log("下一题",this.nextquestionOptions.title)
      setTimeout(() => {

        $(".Ac").css("transition","")
          this.active=this.next
          this.questionOptions=Object.assign({},this.nextquestionOptions)

          this.xia=false
          this.dong= false
      }, 1000)
    }else{
      setTimeout(() => {
        $(".Ac").css("transition","")
          this.active=this.last
          this.questionOptions=Object.assign({},this.lastquestionOptions)
		  this.nextquestionOptions=Object.assign({},this.lastquestionOptions)
          this.shang= false
          this.dong=false
      }, 1000)
    }
  },

  // 获取题目
  questionnaire: function (e) {

    let that = this
    let _data = this.$store.state.questions
	_data.member_id = this.$store.state.member_id
	if(e==1&&(this.currentNum==1)){
		this.alertFN("已经是第一题了")
		return
	}
    if(e==1){
      _data.is_up = 1
      that.endQuestion=false
    }else{
	if(this.endQuestion){                                  //最后一题提交问卷
           this.saveQuestion(_data)
        return
      }

    }
	
    console.log("获取题目",_data)
    this.axios({
            method: 'post',
            url:"index/getQuestion",
            data: _data
          }).then(res=>{
			if(res.data.code==0)return
			that.currentNum = res.data.data.current_num
			that.allNum = res.data.data.question_num
            if (res.data.data.is_end==1){
                that.endQuestion=true
            }
			let _progressBar = (Number(res.data.data.current_num) / Number(res.data.data.question_num) * 100).toFixed(0)
			_progressBar = _progressBar + "%"
			
			 $('.question-schedule').css("width",_progressBar)
			 
			 if(that.log!=res.data.data.type){
				 that.catalogShow = true
				 that.log=res.data.data.type
				 that.autolog()
			 }
			
            if(e==1){
              that.lastQ(res.data.data)      //上一题
            }else{
              that.nestQ(res.data.data)      //下一题
            }
            
          })
  },
  //阻止答题
  stopQuestion(){
	  console.log("阻止答题函数")
	  this.stopQ = true
  },
  //解除阻止答题
  delstopQuestion(){
  	  this.stopQ = false
  },
  // 是否选择答案进行下一题
  goOnQuestion(){
	  console.log("可以答题")
  	  this.keepQ = true
  },
   // 是否选择答案进行下一题
  delgoOnQuestion(){
	  
  	  this.keepQ = false
  },
	// 动画过程,无操作
	nullQuestion(){
	  
	},
  // 提交答案并获取下一题目
  nextQuestionnaire(){
	 
	let _questions = this.$store.state.questions
	
	if(this.stopQ)return
	if(!this.keepQ){

		// this.alertFN("你还没有请选择")
		return
	}
	this.questionnaire(2)
  },
  // 获取上一题
  lastQuestionnaire(){
    this.questionnaire(1)
  },
  // 答案置空
  clearAnswer(){

  },
  // 继续问卷
    keepQuestion(recordId){
      this.axios({
                  method: 'post',
                  url:"index/continueQuestion",
                  data:{
                     member_id:this.$store.state.member_id,
                     record_id:recordId,
                  }
                }).then(res=>{
                      // if(!res.data.data)return
                      // let _questions = that.data.questions
                       let _questions = res.data.data
                        
                      _questions.question = { question_id: res.data.data.id }
                      _questions.record_id = this.record_id
                    
		      this.$store.commit("modifyQuestions",_questions)
                      this.nestQ(_questions) 
                      // this.is_record= res.data.data.is_record||2
                      // this.record_id= res.data.data.record_id||0
                      // this.current_num = res.data.data.current_num||0
                })
    },
   // 提交保存问卷
    saveQuestion:function(_data){
    let that = this
    if(!this.firstPost){
      return
    }else{
      this.firstPost=false
 
    }
    let _questions = {
      record_id: _data.record_id,
      question_id: _data.question.question_id,
      answer_ids: _data.question.answer_ids,
      answer: _data.question.answer,
    }
    this.axios({
      url: 'index/saveQuestion',
      method: 'post',
      data: _questions,
    }).then(res=>{
	this.Qshow = false
	this.end = true
	this.count_id = res.data.count_id
    })
  },
  // 页面提示
  alertFN(msg){
	  console.log(msg)
  	   this.alertShow=true
  	   this.alertMsg=msg
  },
  closeAlertShow(){
  	 this.alertShow = false  
  },
  getMsgFormAlert(eve){
  	   console.log(eve)
  },
}
}
</script>  

<style>

#Questions{
  background:rgba(244,242,240,1);
  width: 7.5rem;
  height: 100%;
  position:relative;
  margin: 0 auto;
  
}

.catalog{
  width: 7.5rem;
  height: 100vh;
  box-sizing: border-box;
  position: absolute;
  z-index: 99;
  top: 0;
  background:rgba(244,242,240,1);
  display: flex;
  flex-direction:column;
  align-items:center;
  padding: 2rem;
}
.sx{
  height:1.05rem;
  width: 0.15rem;
  background-color: #fff;

}
.catalogImg{
  width:1.275rem;
  height: 1.275rem;
  transition: all .6s;
  z-index: 3;
  -webkit-transition: all .6s;
}
.activeImg{
  width:2.55rem;
  height: 2.55rem;
}

.questionBox{
   width: 7.5rem;
  height: 100vh;
  position:relative;
  box-sizing: border-box;
  overflow:hidden;
}
.Ac{
  width: 7.5rem;
  height: 100vh;
  position: absolute;
  top:0;
  text-align: center;
  box-sizing: border-box;
  /*transition: all 1s;*/
}
.doing{
  transition: all 1s;
}
.top{
  left:0;
  
}
.left{
left: -7.5rem;

}
.right{
left: 7.5rem;
}

/*上一题下一题*/
.questionBoxBottom{
  width: 7.5rem;
  height: 2rem;
  position: fixed;
  left: 50%;
  transform: translate(-50%, 0); 
  bottom: 0;
  display: flex;
  justify-content: space-between;
  padding:0.58rem 0.72rem;
  background:rgba(244,242,240,1);
  box-shadow:0 -0.075rem 0.15rem 0 rgba(220,207,191,0.3);
}
.nestQ{
  width: 1.2rem;
  height: 1.2rem;
}
.lastQ{
  display: flex;
  align-items: center;
}
.lastQ img{
   width: 0.225rem;
  height: 0.375rem;
  margin-right: 0.15rem;
  transform:rotate(180deg);
  -ms-transform:rotate(180deg);   /* IE 9 */
  -moz-transform:rotate(180deg);  /* Firefox */
  -webkit-transform:rotate(180deg); /* Safari 和 Chrome */
  -o-transform:rotate(180deg);  /* Opera */
  font-size:0.3rem;
  font-family:PingFangSC-Regular;
  font-weight:400;
  color:rgba(114,113,113,1);
}
.image000{
  -webkit-filter: grayscale(100%);
    -moz-filter: grayscale(100%);
    -ms-filter: grayscale(100%);
    -o-filter: grayscale(100%);
    filter: gray;
    opacity: 0.3;
}


.lastQuestionBtn{
  width:2.1rem;
  height:0.83rem;
  background:rgba(255,255,255,1);
  box-shadow:0px 5px 11px -2px rgba(194,94,77,0.2);
  border-radius:0.42rem;
  font-size:0.32rem;
  font-family:PingFangSC-Regular,PingFang SC;
  font-weight:400;
  color:rgba(194,94,77,1);
  line-height:0.83rem;
}
.nextQuestionBtn{
  width:2.1rem;
  height:0.83rem;
  background:rgba(194,94,77,1);
  box-shadow:0px 5px 11px -2px rgba(194,94,77,0.4);
  border-radius:0.43rem;
  font-size:0.32rem;
  font-family:PingFangSC-Regular,PingFang SC;
  font-weight:400;
  color:rgba(255,255,255,1);
  line-height:0.83rem;
}


/* 题目进度条 */
.question-schedulebox{
    position: absolute;
    top: 0;
    left: 0;
    width: 7.5rem;
    z-index: 9999;
    /* background: rgba(241, 221, 176,0.2); */
    background:rgba(244,242,240,1);
}
.question-schedule {
    width: 20%;
    height: 0.08rem;
    /* background: rgba(241, 221, 176, 1); */
    background:rgba(194,201,191,1);
}
</style>